import { render, staticRenderFns } from "./newspage.vue?vue&type=template&id=73d46662"
import script from "./newspage.vue?vue&type=script&lang=js"
export * from "./newspage.vue?vue&type=script&lang=js"
import style0 from "./newspage.vue?vue&type=style&index=0&id=73d46662&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports